export class RingBuffer<T> {
  private buffer: T[];
  private capacity: number;
  private current = -1;

  constructor(capacity: number) {
    this.capacity = capacity;
    this.buffer = [];
  }

  push(item: T): void {
    // If we’re in the middle (after undo), drop forward history
    if (this.current < this.buffer.length - 1) {
      this.buffer.splice(this.current + 1, Infinity);
    }

    if (this.buffer.length === this.capacity) {
      this.buffer.push(item);
      this.buffer.shift();
    } else {
      this.buffer.push(item);
    }

    this.current = this.buffer.length - 1;
  }

  undo(): T | undefined {
    if (this.current <= 0) return undefined;
    this.current--;
    return this.get(this.current);
  }

  redo(): T | undefined {
    if (this.current >= this.buffer.length - 1) return undefined;
    this.current++;
    return this.get(this.current);
  }

  get(index: number): T | undefined {
    if (index < 0 || index >= this.buffer.length) return undefined;
    return this.buffer[index];
  }

  currentItem(): T | undefined {
    return this.get(this.current);
  }

  clear(): void {
    this.buffer = [];
    this.current = -1;
  }

  get canUndo(): boolean {
    return this.current > 0;
  }

  get canRedo(): boolean {
    return this.current < this.buffer.length - 1;
  }
}
